/* eslint-disable react-hooks/exhaustive-deps */
import { GET_LIST_REQUEST_DEFAULT_LIMIT } from "constants/common";
import { useManageTable } from "hooks";
import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

import { useGetAuditLogs } from "../apis";
import { AuditLogsRequestParams } from "../auditLog.types";
import {
  ACTION_FILTER_SEARCH_PARAMETER,
  ADMIN_ID_FILTER_SEARCH_PARAMETER,
  DATE_RANGE_FILTER_SEARCH_PARAMETER,
  ENTITY_ID_FILTER_SEARCH_PARAMETER,
  ENTITY_TYPE_FILTER_SEARCH_PARAMETER
} from "../constants";

const useAuditLogsList = () => {
  const {
    page,
    sorting,
    setSorting,
    setPage
  } = useManageTable({ defaultSorting: [{ id: "createdAt", desc: true }] });

  const [searchParams] = useSearchParams();

  const requestParams: AuditLogsRequestParams = useMemo(
    () => ({
      page,
      take: GET_LIST_REQUEST_DEFAULT_LIMIT,
      // Default newest-first per the handoff doc (backend defaults to ASC).
      order: sorting[0] ? (sorting[0]?.desc ? "DESC" : "ASC") : "DESC",
      adminId: searchParams.get(ADMIN_ID_FILTER_SEARCH_PARAMETER) || undefined,
      action: searchParams.get(ACTION_FILTER_SEARCH_PARAMETER) || undefined,
      entityType:
        searchParams.get(ENTITY_TYPE_FILTER_SEARCH_PARAMETER) || undefined,
      entityId:
        searchParams.get(ENTITY_ID_FILTER_SEARCH_PARAMETER) || undefined,
      dateFrom:
        searchParams.getAll(DATE_RANGE_FILTER_SEARCH_PARAMETER)[0] || undefined,
      dateTo:
        searchParams.getAll(DATE_RANGE_FILTER_SEARCH_PARAMETER)[1] || undefined
    }),
    [page, sorting, searchParams]
  );

  const { auditLogs, meta, isLoading, refetch } =
    useGetAuditLogs(requestParams);

  return {
    auditLogs,
    totalItems: meta?.itemCount ?? 0,
    page,
    sorting,
    isLoading,
    setSorting,
    setPage,
    refetchAuditLogs: refetch
  };
};

export default useAuditLogsList;
